export const REQUEST_FOR_MAPPED_COMPANYNAME = 'REQUEST_FOR_MAPPED_COMPANYNAME';
export const RESPONSE_FOR_MAPPED_COMPANYNAME = 'RESPONSE_FOR_MAPPED_COMPANYNAME';
export const REQUEST_FOR_COMPANYNAME_SEARCH = 'REQUEST_FOR_COMPANYNAME_SEARCH';
export const RESPONSE_FOR_COMPANYNAME_SEARCH = 'RESPONSE_FOR_COMPANYNAME_SEARCH';
export const REQUEST_FOR_SAVE_MAPPED_COMPANYNAMES = 'REQUEST_FOR_SAVE_MAPPED_COMPANYNAMES';
export const RESPONSE_SAVE_MAPPED_COMPANIES_SUCCESS = 'RESPONSE_SAVE_MAPPED_COMPANIES_SUCCESS';
export const RESPONSE_SAVE_MAPPED_COMPANIES_FAILURE = 'RESPONSE_SAVE_MAPPED_COMPANIES_FAILURE';

export const requestMappedCompanyName = (id) => {
    return {
        type: REQUEST_FOR_MAPPED_COMPANYNAME,
        id
    }
}

export const responseMappedCompanyName = (data) => {
    return {
        type: RESPONSE_FOR_MAPPED_COMPANYNAME,
        data
    }
}

export const requestCompanyNameSearch = (data) => {
    return {
        type: REQUEST_FOR_COMPANYNAME_SEARCH,
        data
    }
}

export const responseCompanyNameSearch = (data) => {
    return {
        type: RESPONSE_FOR_COMPANYNAME_SEARCH,
        data
    }
}

export const requestSaveMappedCompanies = (data) => {
    return {
        type: REQUEST_FOR_SAVE_MAPPED_COMPANYNAMES,
        data
    }
}

export const responseSaveMappedCompaniesSuccess = (data) => {
    return {
        type: RESPONSE_SAVE_MAPPED_COMPANIES_SUCCESS,
        data
    }
}
export const responseSaveMappedCompaniesFailure = (data) => {
    return {
        type: RESPONSE_SAVE_MAPPED_COMPANIES_FAILURE,
        data
    }
}